import * as _ from 'lodash';

import { AssetClassColourArray, AssetClassNameArray } from "./enums/AssetClassType";
import { PortfolioUtilities } from './portfolio.utilities';

class ItemListController implements angular.IOnInit, angular.IOnChanges {
  public items: { name: string, total: number }[];
  public displayCurrency: string; // Possible Enum: DisplayCurrencies or Currencies
  public showIndicators: boolean;

  public itemsTotal: number;

  /** @ngInject */
  constructor(private portfolioUtilities: PortfolioUtilities) { }

  $onInit(): void {
    if (this.items)
      this.itemsTotal = this.items.reduce((total, current) => total + current.total, 0);

  }

  $onChanges(onChangesObj: angular.IOnChangesObject): void {
    if (onChangesObj.items  &&
      onChangesObj.items.currentValue){
        this.itemsTotal = this.items.reduce((total, current) => total + current.total, 0);
      }

  }

  getItemColour(assetClass: string) {
    return AssetClassColourArray[AssetClassNameArray.indexOf(assetClass)]
  }

  public formatCurrency() {
    return this.portfolioUtilities.formatCurrency(this.displayCurrency);
  }

  public formatName(name: string) {
    return _.startCase(name);
  }

  public getPercentage(item: { name: string, total: number }) {
    return (item.total / this.itemsTotal) * 100;
  }
}

export const itemList: angular.IComponentOptions = {
  controller: ItemListController,
  template: require('./itemList.component.html'),
  bindings: {
    items: '<',
    displayCurrency: '<',
    showIndicators: '<'
  }
}



// WEBPACK FOOTER //
// ./src/app/common/itemList.component.ts